"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ELegacyEquipmentSlotType;
(function (ELegacyEquipmentSlotType) {
    /*
       This is only being used for legacy item data and not being used in future.
       The Possible equipment slot for an itemType (not item) will be controlled via
       EquipmentSlotType.allowsItemTypes
      */
    ELegacyEquipmentSlotType["BOTH_HANDS"] = "BOTH_HANDS";
    ELegacyEquipmentSlotType["LEFT_HAND"] = "LEFT_HAND";
    ELegacyEquipmentSlotType["RIGHT_HAND"] = "RIGHT_HAND";
    ELegacyEquipmentSlotType["BACK"] = "BACK";
    ELegacyEquipmentSlotType["FINGER"] = "FINGER";
    ELegacyEquipmentSlotType["CHEST"] = "CHEST";
    ELegacyEquipmentSlotType["LEGS"] = "LEGS";
    ELegacyEquipmentSlotType["ARMS"] = "ARMS";
    ELegacyEquipmentSlotType["FEET"] = "FEET";
    ELegacyEquipmentSlotType["HEAD"] = "HEAD";
    ELegacyEquipmentSlotType["NECK"] = "NECK";
    ELegacyEquipmentSlotType["BAG"] = "BAG";
    ELegacyEquipmentSlotType["QUEST_BAG"] = "QUEST_BAG";
})(ELegacyEquipmentSlotType || (ELegacyEquipmentSlotType = {}));
exports.default = ELegacyEquipmentSlotType;
//# sourceMappingURL=ELegacyEquipmentSlotType.js.map